// extracted by mini-css-extract-plugin
export var label = "_dg-5";
export var slideContainer = "_dg-0";
export var slider = "_dg-1";
export var sliderLg = "_dg-4";
export var sliderMd = "_dg-3";
export var sliderSm = "_dg-2";